<script setup lang="ts">
// Footer build stamp. Values are compile-time constants replaced by Vite from
// vite.config.ts — no runtime cost, no network call.
const version = __APP_VERSION__;
const commit = __APP_COMMIT__;
const builtAt = __APP_BUILT_AT__;

// Hover title gets the full ISO timestamp; visible text stays compact.
const title = `Build ${version} · commit ${commit} · ${builtAt}`;
</script>

<template>
  <span
    class="font-body lowercase text-[11px] text-white opacity-40 hover:opacity-80 transition-opacity select-text"
    :title="title"
  >
    v{{ version }}
  </span>
</template>
